module.exports = __webpack_public_path__ + "img/T4-D-rc_29.6e61ce49.png";